module.exports = __webpack_public_path__ + "img/image16.c4b1e62a.png";